var sellstart_isodate, url_mod, url_real;

url_real = "./data/seat-stock.json";

url_mod = "./data/seat-stock-mod.json";

sellstart_isodate = "2016-10-15T13:00:00+09:00";

module.exports = {
  sync: function() {
    var fetch_count, processData, seat_stock, seat_stock_mod;
    fetch_count = 0;
    seat_stock = [];
    seat_stock_mod = [];
    processData = function() {
      var $thisrow, after, i, idx, isodate, len, now, sellstart, sign_text, val;
      if (++fetch_count < 2) {
        return;
      }
      sellstart = new Date(sellstart_isodate);
      now = new Date();
      for (idx = i = 0, len = seat_stock.length; i < len; idx = ++i) {
        val = seat_stock[idx];
        $thisrow = $(".main-schedule-timetable > tbody > tr:eq(" + (idx + 1) + ")");
        isodate = $thisrow.attr("isodate");
        after = new Date(isodate);
        if (now < sellstart || after < now) {
          sign_text = "―";
        } else {
          if (val > seat_stock_mod[idx]) {
            val = seat_stock_mod[idx];
          }
          if (val >= 41) {
            sign_text = "&#x25CB;";
          } else if ((40 >= val && val >= 26)) {
            sign_text = "&#x25B3;";
          } else if ((25 >= val && val >= 1)) {
            sign_text = "僅少";
          } else if (0 >= val) {
            sign_text = "完売";
          }
        }
        $thisrow.children(".main-schedule-timetable-sold").html(sign_text);
      }
    };
    $.getJSON(url_real, function(data_real, textStatus, jqXHR) {
      seat_stock = data_real.seat_stock;
      return processData();
    });
    $.getJSON(url_mod, function(data_mod, textStatus, jqXHR) {
      seat_stock_mod = data_mod.seat_stock;
      return processData();
    });
    console.log("[" + (new Date()) + "] Timetable synced.");
    setTimeout(this.sync, 300000);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VhdC1zdG9jay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNlYXQtc3RvY2suY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLElBQUE7O0FBQUEsUUFBQSxHQUFXOztBQUNYLE9BQUEsR0FBVzs7QUFDWCxpQkFBQSxHQUFvQjs7QUFFcEIsTUFBTSxDQUFDLE9BQVAsR0FDQztFQUFBLElBQUEsRUFBTSxTQUFBO0FBQ0wsUUFBQTtJQUFBLFdBQUEsR0FBYztJQUNkLFVBQUEsR0FBa0I7SUFDbEIsY0FBQSxHQUFrQjtJQUNsQixXQUFBLEdBQWMsU0FBQTtBQUNiLFVBQUE7TUFBQSxJQUFHLEVBQUUsV0FBRixHQUFnQixDQUFuQjtBQUNDLGVBREQ7O01BRUEsU0FBQSxHQUFnQixJQUFBLElBQUEsQ0FBSyxpQkFBTDtNQUNoQixHQUFBLEdBQVUsSUFBQSxJQUFBLENBQUE7QUFDVixXQUFBLHdEQUFBOztRQUNDLFFBQUEsR0FBVyxDQUFBLENBQUUsMkNBQUEsR0FBMkMsQ0FBQyxHQUFBLEdBQU0sQ0FBUCxDQUEzQyxHQUFvRCxHQUF0RDtRQUNYLE9BQUEsR0FBVSxRQUFRLENBQUMsSUFBVCxDQUFjLFNBQWQ7UUFDVixLQUFBLEdBQVksSUFBQSxJQUFBLENBQUssT0FBTDtRQUNaLElBQUcsR0FBQSxHQUFNLFNBQU4sSUFBbUIsS0FBQSxHQUFRLEdBQTlCO1VBQ0MsU0FBQSxHQUFZLElBRGI7U0FBQSxNQUFBO1VBR0MsSUFBNkIsR0FBQSxHQUFNLGNBQWUsQ0FBQSxHQUFBLENBQWxEO1lBQUEsR0FBQSxHQUFNLGNBQWUsQ0FBQSxHQUFBLEVBQXJCOztVQUNBLElBQWMsR0FBQSxJQUFPLEVBQXJCO1lBQ0MsU0FBQSxHQUFZLFdBRGI7V0FBQSxNQUVLLElBQUcsQ0FBQSxFQUFBLElBQU0sR0FBTixJQUFNLEdBQU4sSUFBYSxFQUFiLENBQUg7WUFDSixTQUFBLEdBQVksV0FEUjtXQUFBLE1BRUEsSUFBRyxDQUFBLEVBQUEsSUFBTSxHQUFOLElBQU0sR0FBTixJQUFhLENBQWIsQ0FBSDtZQUVKLFNBQUEsR0FBWSxLQUZSO1dBQUEsTUFHQSxJQUFHLENBQUEsSUFBSyxHQUFSO1lBRUosU0FBQSxHQUFZLEtBRlI7V0FYTjs7UUFjQSxRQUFRLENBQUMsUUFBVCxDQUFrQiwrQkFBbEIsQ0FDQSxDQUFDLElBREQsQ0FDTSxTQUROO0FBbEJEO0lBTGE7SUEyQmQsQ0FBQyxDQUFDLE9BQUYsQ0FBVSxRQUFWLEVBQW9CLFNBQUMsU0FBRCxFQUFZLFVBQVosRUFBd0IsS0FBeEI7TUFDbEIsYUFBYzthQUNmLFdBQUEsQ0FBQTtJQUZtQixDQUFwQjtJQUlBLENBQUMsQ0FBQyxPQUFGLENBQVUsT0FBVixFQUFtQixTQUFDLFFBQUQsRUFBVyxVQUFYLEVBQXVCLEtBQXZCO01BQ04saUJBQWtCLFNBQTdCO2FBQ0QsV0FBQSxDQUFBO0lBRmtCLENBQW5CO0lBSUEsT0FBTyxDQUFDLEdBQVIsQ0FBWSxHQUFBLEdBQUcsQ0FBSyxJQUFBLElBQUEsQ0FBQSxDQUFMLENBQUgsR0FBZSxxQkFBM0I7SUFDQSxVQUFBLENBQVcsSUFBQyxDQUFBLElBQVosRUFBa0IsTUFBbEI7RUF4Q0ssQ0FBTiJ9
